import React from 'react';
import dayjs from 'dayjs';
import Event from '@/model/Event';
import { ColumnImage, ColumnStatus, CustomTable, TableColumn } from '@/components/Table';
import { ActionProps as ActionPropsMenu } from '@/components/DropdownMenu';
import UserType from '@/model/UserType';
import { DropdownMenu } from '@/components';
import { ReactComponent as EventAction } from '@/assets/images/svg/eventAction.svg';
import { DataRow } from '../../screens/list/ui';

interface ChildTableProps {
  events: Event[];
  userType: UserType;
  changeColorColumn: (status: number) => string;
  columns: TableColumn<DataRow>[];
  onRowClick: (id: string) => void;
  mountMenuActions: (event: Event) => ActionPropsMenu[];
}

export const ChildTable: React.FC<ChildTableProps> = ({
  events,
  userType,
  columns,
  changeColorColumn,
  onRowClick,
  mountMenuActions,
}) => {
  const dataTablePos = events?.map(event => ({
    id: event.id,
    eventId: event.id,
    eventType: event.eventType,
    childs: event.childs ?? [],
    childCount: event.childCount ?? 0,
    image: (
      <ColumnStatus justify="right" statusColor={String(changeColorColumn(event.eventStatus))}>
        <ColumnImage srcImage={event.imageBase64} />
      </ColumnStatus>
    ),
    name: (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div>{event.name}</div>
      </div>
    ),
    city: `${event.address.city}/${event.address.state}`,
    startDate:
      event.startDate === null
        ? '-----'
        : // eslint-disable-next-line no-useless-concat
          `${dayjs(event.startDate).format('DD/MM/YYYY')} às ${String(event.startDate)
            .split('T')[1]
            .slice(0, 5)}`,
    endDate:
      event.endDate === null
        ? '-----'
        : `${dayjs(event.endDate).format('DD/MM/YYYY')} às ${String(event.endDate)
            .split('T')[1]
            .slice(0, 5)}`,
    actions:
      userType === UserType.CONTRACTOR ||
      userType === UserType.PDV ||
      userType === UserType.SUB_PDV ||
      userType === UserType.ARTIST ? (
        ''
      ) : (
        <DropdownMenu title={<EventAction />} actions={mountMenuActions(event)} />
      ),
  }));

  return (
    <div
      style={{
        marginBottom: 20,
        marginLeft: 20,
        marginRight: 20,
        backgroundColor: '#F7F7F7',
        overflow: 'visible',
        position: 'relative',
      }}
    >
      <CustomTable
        theme="childsEvents"
        columns={columns}
        data={dataTablePos}
        numberRowsPerPage={5}
        progressPending={false}
        getRowId={row => onRowClick(row.id)}
      />
    </div>
  );
};
